"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const PriceVatLabelView = () => react_1.default.createElement("div", null,
    "M\u011Bs\u00ED\u010Dn\u011B\u00A0",
    react_1.default.createElement("span", { className: "withoutVat" }, "bez\u00A0DPH"),
    react_1.default.createElement("span", { className: "withVat" }, "s\u00A0DPH"));
exports.default = PriceVatLabelView;
